import { Component, OnInit, Input, AfterViewInit, AfterViewChecked, OnDestroy } from '@angular/core';
import { ValueAccessorBase } from '../../shared/value-accessor/value-accessor-base';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ActionsService } from '../../../../services/actions-service/actions.service';
import { RestProviderService } from '../../../../services/rest-provider/rest-provider.service';
import { SemParameterDialogComponent } from '../../dialogs/sem-parameter-dialog/sem-parameter-dialog.component';
import { RequestModel } from 'src/app/models/request/request-model';
import { HeroHighlightModel } from '../../../../models/control-models/hero-highlight-model';
import { Subscription } from 'rxjs';

@Component({
    selector: 'sem-quick-actions',
    templateUrl: './sem-quick-actions.component.html',
    styleUrls: ['./sem-quick-actions.component.css'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: SemQuickActionsComponent, multi: true }
    ],
    standalone: false
})
export class SemQuickActionsComponent extends ValueAccessorBase<string> implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {

  private static readonly DefaultIconColor = '#3b82f6';
  private static readonly HexColorPattern = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i;

  ngAfterViewChecked() {
  }

  @Input() settings: any;

  private restService: RestProviderService;
  public qaValue: number | null = null;
  public actionCalled = false;
  public actionPostResponseTitleValue: string = null;
  public showLoaderAction: boolean = false;
  private filterSub: Subscription;

  super() { }

  ngOnInit() {
    this.sidebarMenuOpened = true;
    this.actionsService = this.injector.get(ActionsService);
    this.restService = this.injector.get(RestProviderService);
    this.filterSub = this.dfms.bindValueChange.subscribe((event: any) => {
      if (event?.type === 'statistics-filter-refresh') {
        this.refresh();
      }
    });
  }

  ngAfterViewInit() {
    let test = this.settings;
  }

  ngOnChanges() {
    if (this.settings?.Actions[0]) {
      if (this.settings?.["QuickActionType"] == 1) {
        this.callAction(this.settings?.Actions[0]);
      }
    }
  }

  ngOnDestroy() {
    if (this.filterSub) {
      this.filterSub.unsubscribe();
    }
  }

  public refresh() {
    this.actionCalled = false;
    this.qaValue = null;
    this.actionPostResponseTitleValue = null;
    if (this.settings?.Actions[0]) {
      this.callAction(this.settings.Actions[0]);
    }
  }

  private resolveBindingValue(bindingPath: string): any {
    const directPath = bindingPath as string;
    const normalizedPath = directPath.startsWith("model.") ? directPath.replace(/^model\./, "") : directPath;
    return this.dfms?.getValue(this.model, normalizedPath);
  }

  private buildUrlWithParams(baseUrl: string, action: any): string {
    if (!action?.QueryParameters) {
      return baseUrl;
    }

    const urlParts = baseUrl.split('?');
    const path = urlParts[0];
    const existingParams = new URLSearchParams(urlParts[1] || '');

    for (const [paramName, bindingPath] of Object.entries(action.QueryParameters)) {
      const value = this.resolveBindingValue(bindingPath as string);
      if (value != null && typeof value !== 'undefined' && value !== '') {
        let formatted = value;
        try {
          if ((value as any).toISOString) {
            formatted = (value as any).toISOString();
          }
        } catch (e) { }
        existingParams.set(paramName, formatted as string);
      } else {
        existingParams.delete(paramName);
      }
    }

    const qs = existingParams.toString();
    return qs ? `${path}?${qs}` : path;
  }

  callAction(action) {
    if (!this.actionCalled) {
      this.actionCalled = true;
      if (action) {
        const url = this.buildUrlWithParams(action["ActionName"], action);
        if (action["ActionType"]?.toLowerCase() == "post") {
          let rModel = new RequestModel;
          rModel.url = url;
          rModel.data = { "Envelope": action["Body"] };

          this.restProviderService.getDataPOST(rModel).subscribe((data: number) => {
            this.qaValue = data;

            this.changeDetection.detectChanges();

          }, error => {
            console.error("Quick Action error:", error);
            this.qaValue = null;
            this.actionPostResponseTitleValue = null;
            this.changeDetection.detectChanges();
          });

        }
        else if (action["ActionType"]?.toLowerCase() == "post-new") {
          let rModel = new RequestModel;
          rModel.url = url;
          rModel.data = { "Envelope": action["Body"] };

          this.restProviderService.getDataPOST(rModel).subscribe((data: HeroHighlightModel) => {
            this.qaValue = data.Number;
            this.actionPostResponseTitleValue = data.Title;

            this.changeDetection.detectChanges();

          }, error => {
            console.error("Quick Action error:", error);
            this.qaValue = null;
            this.actionPostResponseTitleValue = null;
            this.changeDetection.detectChanges();
          });
        } else if (action["ActionType"]?.toLowerCase() == "get") {
          this.restProviderService.getDataGET(url).subscribe((data: any) => {
            this.qaValue = data;

            this.changeDetection.detectChanges();

          }, error => {
            console.error("Quick Action error:", error);
            this.qaValue = null;
            this.actionPostResponseTitleValue = null;
            this.changeDetection.detectChanges();
          });
        }
      }
    }
  }

  getActionTitle(actionTitle: string) {

    if (actionTitle != null && actionTitle !== undefined && actionTitle.length > 0) {
      return this.translationsService.translate(actionTitle);
    } else {
      return this.actionPostResponseTitleValue;
    }
  }

  getActionDescription(description: string): string {
    return description ? this.translationsService.translate(description) : '';
  }

  getIconColor(color: string): string {
    return this.normalizeIconColor(color);
  }

  getIconBackgroundColor(backgroundColor: string, iconColor: string): string {
    if (SemQuickActionsComponent.HexColorPattern.test(backgroundColor || '')) {
      return backgroundColor;
    }
    const normalizedColor = this.normalizeIconColor(iconColor);
    const expandedColor = normalizedColor.length === 4
      ? `#${normalizedColor[1]}${normalizedColor[1]}${normalizedColor[2]}${normalizedColor[2]}${normalizedColor[3]}${normalizedColor[3]}`
      : normalizedColor;
    const red = parseInt(expandedColor.substring(1, 3), 16);
    const green = parseInt(expandedColor.substring(3, 5), 16);
    const blue = parseInt(expandedColor.substring(5, 7), 16);

    return `rgba(${red}, ${green}, ${blue}, 0.12)`;
  }

  private normalizeIconColor(color: string): string {
    return SemQuickActionsComponent.HexColorPattern.test(color || '')
      ? color
      : SemQuickActionsComponent.DefaultIconColor;
  }

  actionClick(url: string, action: any) {
    if (action != null && typeof action != "undefined") {
      if (action.ActionName != null && typeof action.ActionName != "undefined") {

        this.showLoaderAction = true;
        this.restService.getDataGET("api/actions/" + action.ActionName, "application/json").subscribe(data => {

          let formAction = JSON.parse(data);


          //eval(action.NavigationNodeRule.ActionBody);
          // if form actions has parameter form linked then we should first show popup with parameter form
          if (formAction.ParameterForm != null && typeof formAction.ParameterForm != "undefined" && formAction.ParameterForm.Id > 0) {
            var reportId = null;
            if (formAction.ParameterForm.Report != null && typeof formAction.ParameterForm.Report != "undefined") {
              reportId = formAction.ParameterForm.Report.Id;
            }

            const dialogRef = this.dialog.open(SemParameterDialogComponent, {
              data: {
                parameterFormId: formAction.ParameterForm.Id,
                reportId: reportId,
                customHeaderTitle: formAction.ParameterForm.CustomHeaderTitle,
                customCssClass: formAction.ParameterForm.CustomCssClass
              }
            });

            dialogRef.afterClosed().subscribe(returnData => {
              if (returnData != null && typeof returnData != "undefined") {
                // only call action if parameter popup was confirmed (not cancled - close button)
                if (returnData.Canceled == false) {
                  var inputParametersModel = returnData["Model"];
                  this.actionsService.callAction(formAction, this.model, null, null, this, false, inputParametersModel,
                    formAction.OnlyClientLogic, false, false, formAction.SkipBulkActionApiMethod);
                    this.showLoaderAction = false;
                }else{
                  this.showLoaderAction = false;
                }
              }
            });
          } else {
            // just call action without parameters form popup
            this.actionsService.callAction(formAction, this.model, null, null, this, false, null,
              formAction.OnlyClientLogic, false, false, formAction.SkipBulkActionApiMethod);
            this.showLoaderAction = false;
          }


        }, error => {
          console.log(error);
        });
      } else {
        this.utility.processNavigationUrl(url);
      }
    }
  }

  navigate(url){
    this.utility.processNavigationUrl(url);
  }

}
